import React, { useState } from 'react';
import Loader from "react-loader-spinner";
import { MdClose } from 'react-icons/md';
import * as jobsActions from '../../Redux/Actions/jobs';
import { toastMessage } from '../../utils/toast';

const ReceiptModal = ({ t, showModal, loading, handleCancel, referenceEditData }) => {

    const [buttonLoading, setButtonLoading] = useState(false);

    const statusHandler = () => {
        setButtonLoading(true);
        let payload = {
            referenceId: referenceEditData && referenceEditData.id,
            status: 'Processed'
        };
        jobsActions.updateReferenceStatusModel(payload).then(res => {
            if (res && res.data) {
                toastMessage('success', 'Status changed successfully.');
                setButtonLoading(false);
                handleCancel();
                window.location.reload();
            } else {
                setButtonLoading(false);
                toastMessage('error', (res && res.message) || 'Try again later');
            }
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err && err.message) || 'Try again later');
        });
    }

    return (
        <div>
            <div className="modal" style={{ display: (showModal ? 'block' : '') }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.receiptStatus.title")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{ border: 'none' }}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>{t("jobsManagement.infoJob.receiptStatus.receiptProcessed")}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" disabled={loading || buttonLoading} onClick={handleCancel}>{t("jobsManagement.infoJob.receiptStatus.cancel")}</button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading || buttonLoading} onClick={() => { statusHandler(); }}>
                                {t("jobsManagement.infoJob.receiptStatus.processed")} {(loading || buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{ marginLeft: '10px' }} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default ReceiptModal;
